import styled from 'styled-components'

const SmsStyle = styled.div``
export default SmsStyle
